<template>
  <div class='forgot-password-form'>
    <h3 class='modal__title'>{{ locales && locales.common && locales.common.forgot_password }}</h3>
    <h4 class='modal__sub-title'>{{ locales && locales.common && locales.common.forgot_password_text }}</h4>
    <div
      class='login-form__caps-warning'
      v-show='capsLockEnabled'
      v-text='locales.common && locales.common.capsWarning'
    />
    <div class='login-form__input-box'>
      <div class='login-form__label'>{{ locales && locales.common && locales.common.your_email }}
        <span class='login-form__label-asterisk'>*</span>
      </div>
      <div style='position: relative;'>
        <input
          :class="['login-form__input', { 'login-form__input-invalid': errors.has('email') }]"
          :placeholder='locales && locales.common && locales.common.enter_your_email'
          type='text'
          name='email'
          v-model='forgotPasswordEmail'
          v-validate='`required`'
          @keyup.enter='forgotPasswordSend'
          @keypress='checkCaps'
          @keydown='capsLockToggle'
        />
        <span
          v-if="errors.has('email')"
          class='icon-warning login-form__icon-error'
        />
      </div>
      <div class='login-form__error' v-if="errors.has('email')">
        {{ errors.first('email') }}
      </div>
    </div>
    <div class='login-form__button-box'>
      <button class='theme-btn theme-btn--theme theme-btn--block' @click.prevent='forgotPasswordSend'>
        Send email
      </button>
    </div>
    <button class='theme-btn theme-btn--tertiary theme-btn--block' @click.prevent='backToLogin'>
      <i class='icon-thin-left'/>
      Go to Login
    </button>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import sweetalert from 'sweetalert';

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      forgotPasswordLink: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        capsLockEnabled: null,
        isTouchDevice: false,
        forgotPasswordEmail: '',
      };
    },
    mounted() {
      this.checkTouchDevice();
    },
    computed: {
      ...mapGetters(['locales']),
    },
    methods: {
      checkTouchDevice() {
        var md = new MobileDetect(window.navigator.userAgent);
        if (
          (md.mobile() !== '' && md.mobile() !== null) ||
          (md.tablet() !== '' && md.tablet() !== null)
        ) {
          this.isTouchDevice = true;
        }
      },
      capsLockToggle(e) {
        if (this.isTouchDevice) return;
        if (e.keyCode == 20 && this.capsLockEnabled !== null) {
          this.capsLockEnabled = !this.capsLockEnabled;
        }
      },
      getChar(e) {
        if (e.which == null) {
          return String.fromCharCode(e.keyCode); // IE
        }
        if (e.which != 0 && e.charCode != 0) {
          return String.fromCharCode(e.which); // rest
        }
        return null;
      },
      checkCaps(e) {
        if (this.isTouchDevice) return;
        var chr = this.getChar(e);
        if (!chr) return;
        if (chr.toLowerCase() == chr.toUpperCase()) return;
        this.capsLockEnabled =
          (chr.toLowerCase() == chr && e.shiftKey) ||
          (chr.toUpperCase() == chr && !e.shiftKey);
      },
      backToLogin() {
        this.$emit('goToLogin');
      },
      forgotPasswordSend() {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            // window.alert('Forgot password send');
            $.ajax({
              url: this.forgotPasswordLink,
              method: 'post',
              data: {
                token: this.token,
                email: this.forgotPasswordEmail,
              },
              success: (response) => {
                this.forgotPasswordEmail = '';
                this.$validator.reset();
                sweetalert(window.app.locales.common.success, '', 'success');
              },
              error: () => {
                sweetalert(window.app.locales.common.error, 'Something went wrong', 'error');
              },
            });
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/PasswordForm.vue